import { createSelector } from 'reselect'

const selectorFactory = (countrySelector) =>
  createSelector(countrySelector, (country) => country.isBuySupported)

const isBuySupportedInCountrySelectorDefinition = {
  id: 'isBuySupportedInCountry',
  selectorFactory,
  dependencies: [{ selector: 'country' }],
}

export default isBuySupportedInCountrySelectorDefinition
